import { componentSizeRoutine } from '@/store/modules/geometricBackground/routines'

export default {
  [componentSizeRoutine.TRIGGER](context, payload) {
    context.commit(componentSizeRoutine.TRIGGER, payload)
  }
}
